import React from 'react';

import { Table } from './Table';
import { TableBody } from './TableBody';
import { TableCell } from './TableCell';
import { TableContainer } from './TableContainer';
import { TableFooter } from './TableFooter';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';

import type { DataTableProps } from './Table.types';

export const DataTable = ({
  header,
  data,
  footer,
  testid = 'data-table',
}: DataTableProps): JSX.Element => {
  return (
    <TableContainer>
      <Table className='data-table' testid={testid}>
        {header && (
          <TableHead>
            <TableRow>
              {header.map((headerCell, i) => (
                <TableCell key={i}>{headerCell}</TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {data.map((row, i) => (
            <TableRow key={i}>
              {row.map((cell, j) => (
                <TableCell key={j}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
        {footer && (
          <TableFooter>
            <TableRow>
              {footer.map((footerCell, i) => (
                <TableCell key={i}>{footerCell}</TableCell>
              ))}
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};
